export async function fbPostCheck(request, response, store) {
  const { action, comment } = response
  await store.dispatch('requests/sendCheckStage', {
    item: request,
    action,
    comment
  })
  return response
}
